<template>
    <div class="recharge-wrap recharge">
        <!--站点充值-->
        <el-form ref="form" :model="rechargefrom" label-width="90px" label-position="left" class="recharge-content">

            <el-form-item label="站点选择：">
                <el-select v-model="rechargefrom.siteno" placeholder="请选择" class="site-list"
                    @change="singleChangeHandle">
                    <el-option
                    v-for="item in sitesList"
                    :key="item.siteno"
                    :label="item.sitename"
                    :value="item.siteno">
                    </el-option>
                </el-select>
                <el-button class="form-right" type="primary" icon="el-icon-refresh" circle @click="singleChangeHandle"></el-button>

                <!--站点是否可用-->
                <div class="recharge-message" v-if="!siteEnable">
                    <i class="iconfont icon-weixian"></i>
                    <span class="label">站点状态：</span>
                    <span>{{siteEnable?"可用":"不可用"}}</span>
                    <span class="label">操作状态：</span>
                    <span>{{rechargefrom.remoteStatus==102?"操作进行中":"等待命令"}}</span>
                </div>

            </el-form-item>

            <el-form-item label="充值金额：" class="recharge-item">
                <el-radio-group v-model="pricetype" class="money-wrap">
                    <el-radio label="1000"></el-radio>
                    <el-radio label="2000"></el-radio>
                    <el-radio label="5000"></el-radio>
                    <el-radio label="10000"></el-radio>
                    <el-radio label="20000"></el-radio>
                    <el-radio label="50000"></el-radio>

                    <el-radio label="自定义"></el-radio>
                    <el-input v-if="pricetype=='自定义'" size="small" @input="handleEdit" v-model="rechargefrom.customize" class="customize"></el-input>
                </el-radio-group>

                <div class="recharge-msg-wrap" v-if="!siteEnable">
                    <div class="recharge-msg-content"><i class="iconfont icon-weixian"></i>无法进行充值</div>
                </div>
            </el-form-item>
        </el-form>            

        <!--上次充值信息-->
        <div class="old-wrap" v-if="old_recharge" :style="{background:siteEnable?'#fff':'rgb(203 200 200)'}">
            <div class="old-item">
                <div class="item-wrap">
                    <span class="text">上次充值时间：</span>
                    <span class="number">{{old_recharge.create_time}}</span>
                </div>
            </div>
            <div class="old-item">
                <div class="item-wrap first-wrap">
                    <span class="text">上次充值金额：</span>
                    <span class="number">{{old_recharge.amount}}</span>
                </div>
                <div class="item-wrap second-wrap">
                    <span class="text">上次充值余额：</span>
                    <span class="number">{{old_recharge.remaining_amount?old_recharge.remaining_amount:"0.0"}}</span>
                </div>
            </div>
            <div class="old-item">
                <div class="item-wrap first-wrap">
                    <span class="text">上次充值单价：</span>
                    <span class="number">{{old_recharge.price}}</span>
                </div>
            </div>
        </div>

        <div class="btn-array">
            <el-button size="small" type="primary" @click="updateRechargeRecord" :disabled="!siteEnable">费用充值</el-button>
        </div>

    </div>
</template>

<script>
import {recharge,getDeviceData} from "@api/billing";
import _find from "lodash/find"
import _filter from "lodash/filter"
import _findIndex from "lodash/findIndex"

export default {
    name:"recharge",
    props:["sitesList"],
    data(){
        return {
            pricetype:"1000", // 充值金额

            rechargefrom:{
                siteno:-1, // 选中站点列表
                price:200.0,
                customize:0.0, // 自定义金额
                remoteAvaliable:0, // 站点是否可用
                remoteStatus:0, // 远程站点状态
                time:"", // 定时充值时间
                timeabled:false, // 定时充值是否打开
            }, // 充值内容

            old_recharge:null, // 上次充值记录
            old_price:null, // 上次单价信息

        }
    },
    computed:{
        // 充值后的余额
        remaining_amount(){
            let amount=0.0;
            if(this.pricetype!="自定义"){
                amount=this.pricetype;
            }else{
                amount=this.rechargefrom.customize;
            }
            amount=parseFloat(amount);
            if(this.old_recharge){
                amount+=parseFloat(this.old_recharge.remaining_amount);
            }
            // 保留两位小数
            amount=amount.toFixed(2);

            return amount;
        },
        // 站点是否可用，当远程状态码为5xx,201或者202，并且remoteAvaliable==1的时候，站点可用
        siteEnable(){
            let r=this.rechargefrom;
            if(r.remoteAvaliable==1&&(r.remoteStatus==201||r.remoteStatus==202||r.remoteStatus>=500)){
                return true;
            }
            return false;
        },
    },
    watch:{
        // 站点选择改变
        sitesList(){
            let first=Object.keys(this.sitesList)[0];
            // 选中第一个
            this.$set(this.rechargefrom,"siteno",this.sitesList[first].siteno);
        }
    },
    mounted(){
        // 获取第一个可用站点
        let sites=this.sitesList;
        let first=Object.keys(sites)[0];
        // 选中第一个
        this.$set(this.rechargefrom,"siteno",sites[first].siteno);
        // 获取站点是否可用
        this.getDeviceRemaining();
    },
    methods:{
        // 费用充值
        updateRechargeRecord(){
            let siteno=this.rechargefrom.siteno;
            // 充值金额
            let amount=0.0;
            if(this.pricetype!="自定义"){
                amount=this.pricetype;
            }else{
                amount=this.rechargefrom.customize;
            }

            // 获取定时充值时间
            let time=""; // 充值时间
            if(this.rechargefrom.timeabled&&this.rechargefrom.time){
                console.log(this.rechargefrom.time);
                time=this.$moment(this.rechargefrom.time);
                // 判断选择时间是否符合要求，必须大于当前一小时
                let now=this.$moment(new Date());
                now=now.unix();
                time=time.unix();
                if(time-now<3600){
                    this.$message({
                        title: '成功',
                        message: '定时时间不满足要求',
                        type: 'error',
                        duration:2000,
                    });
                    return;
                }
            }

            
            // 执行费用充值
            let remaining_amount=this.remaining_amount||0.0;// 充值后余额
            let old_price=this.old_recharge.price||0.0; // 上一次价格
            let old_amount=this.old_recharge.remaining_amount||0.0; // 上一次充值后余额
            let remaining_flux=this.old_recharge.remaining_flux; // 剩余流量

            let old_price_time=this.old_recharge.price_time;

            let price=old_price; // 本次充值的单价，等于上一次的单价

            // 执行费用充值
            this.rechargeHandle(siteno,price,amount,remaining_amount, old_price,old_amount,remaining_flux,
                    old_price_time,"",time);

            // 温馨提示
            this.$message({
                title: '成功',
                message: '命令已下发，操作结果会以弹窗形式提醒，请误重复操作',
                type: 'success',
                duration:4000,
            });

            // 关闭弹窗
            this.$emit("update");         
        },

        /**
         * 费用充值
         * @param siteno 站点编号
         * @param price 单价
         * @param amount 金额
         * @param remaining_amount 剩余金额
         * @param old_price 上一次单价
         * @param old_amount 上一次金额
         * @param remaining_flux 剩余流量
         * @param old_price_time 上一次修改单价时间
         * @param orderid 订单编号
         */
        async rechargeHandle(siteno,price,amount,remaining_amount,
            old_price,old_amount,remaining_flux,
            old_price_time,orderid,time){

            /**
             * 执行费用充值
             * 第一次是进行费用充值
             * 之后就需要进行状态查询
             * 状态查询和费用充值是两个不同的操作
             */
            let res=await recharge(siteno,price,amount,remaining_amount,old_price,old_amount,remaining_flux,old_price_time,orderid,time);

            // 处理返回结果
            if(res.status&&res.status==200){
                 // 触发进度处理
                this.$bus.$emit("processing","recharge");
                // 刷新数据列表
                this.$bus.$emit("updateRechargeList");
            }
        },
        // 获取设备数据
        getDeviceRemaining(site){
            let siteno=this.rechargefrom.siteno;
            if(site){
                siteno=site.siteno;
            }
            // 查询设备信息
            if(siteno||siteno==0){
                getDeviceData(siteno).then(res=>{
                    if(res.status&&res.status==200){
                        let content=res.content;
                        this.old_recharge=content;

                        let remote_status=content.remote_status; // 远程状态
                        let remote_Avaliable=0;

                        if(remote_status==201||remote_status==202||remote_status>=500){
                            remote_Avaliable=content.remote_avaliable;
                        }else{
                            remote_Avaliable=0;
                        }

                        // 站点不可用
                        this.$set(this.rechargefrom,"remoteAvaliable",remote_Avaliable);
                        this.$set(this.rechargefrom,"remoteStatus",remote_status);

                        // 如果传入的站点存在
                        if(site){
                            site.remoteStatus=remote_status;
                            site.remoteAvaliable=remote_Avaliable;
                        }
                    }
                });
            }
            
        },
        // 单个站点选中改变
        singleChangeHandle(){
            // 执行站点状态检查
            this.getDeviceRemaining();
        },

        // 选中的站点改变
        selectSiteChangeHandle(){
            let siteno=this.rechargefrom.siteno;
            if(siteno||siteno==0){
               let temp=_find(this.sitesList, function(o) { return o.siteno == siteno; });
                temp.price=200.00;
                temp.remoteAvaliable=1; // 站点可用
                temp.remoteStatus=202; // 站点状态
                // 执行站点状态检查
                this.getDeviceRemaining(temp);
            }else{
                this.$message({
                    message:"站点未选择",
                    type:"warning"
                })
            }
        },

        // 输入框格式化
        handleEdit(e) {
            let value = e.replace(/[^\-\d.]/g, '') // 只能输入.和-和数字
            value = value.replace(/^\./g, '')  //第一个字符不能是.
            value = value.replace(/\.{2,}/g, '.') // 不能连续输入.
            value = value.replace(/(\.\d+)\./g, '$1') // .后面不能再输入.
            value = value.replace(/(-)\./g, '$1') // -后面不能输入.
            value = value.replace(/\-{2,}/g, '-') // -只能保留一个
            value = value.replace(/(\d+|\.)-/g, '$1') // 数字和.后面不能接-,不能出现类似11-, 12.-
            value = value.replace(/-(0){2,}/g, "$1") // 不能出现-00,-001,-0001类似
            value = value.replace(/(-)0+(\d+)/g, '$1$2') // 不能出现-01,-02类似
            value = value.replace(/^0+(\d)/, '$1') // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
            value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
            this.$set(this.rechargefrom,"customize",value)
        }
    }
}
</script>

<style lang="scss" scoped>
/** 充值 */
.recharge{
    width: 500px;
    .recharge-content{
        padding:0 50px;

        .site-list{
            width: 180px;
        }

        .recharge-item{
            margin-bottom: 0px;

            .el-form-item__label{
                line-height: 1;
            }
        }

        .money-wrap{
            display: flex;
            flex-wrap: wrap;

            .el-radio{
                width: 30%;
                margin: 10px 0 10px 0;
            }
        }

        .recharge-msg-wrap{ 
            width: 100%;
            position: absolute;
            height: 100%;
            top: 0;
            left: 0;

            .recharge-msg-content{
                position: absolute;
                left: 50%;
                transform: translateX(-80%) translateY(-50%);
                top: 50%;
                background: #fff;
                padding: 20px 25px;
                border: 1px solid;
                border-radius: 5px;
                color: red;
            }
            
        }

        .customize{
            width: 100px;
        }
    }

    .form-right{
        margin-left: 10px;
    }

    .old-wrap{
        border-radius: 5px;
        border:1px solid;
        padding: 10px;
        margin: 0 10px 10px;
        min-height: 30px;

        .old-item{
            display: flex;
            font-size: 14px;
            margin-bottom: 5px;

            .item-wrap{
                width: 50%;
                display: flex;
                .text{
                    width: 100px;
                }

                .number{
                    font-weight: 600;
                    flex: 1;
                }
            }

            .first-wrap{
                width: 50%;
            }

            .second-wrap{
                flex: 1;
            }
        }

        .customize{
            width: 150px;
        }
    }
    .btn-array{
        text-align: center;
    }
}

// 消息内容
.recharge-message{
    color: red;
    padding: 0;
    line-height: initial;
    margin: 5px 0 0 0;
    font-size: 12px;
    text-align: left;

    i{
        vertical-align: text-bottom;
    }

    .label{
        margin-left: 5px;
    }
}

</style>